import { ResourceType } from '../../../resource/enumerations/ResourceType';
import {
    ContentSectionContentMutationResourceSchema,
    defaultContentSectionContentResource,
    useContentSectionContentActions,
} from '../../../resource/resources/artifacts/content/contentSectionContentResource';
import { EditChildBaseDialog } from '../../reusable-components/dialogs/EditChildBaseDialog';
import { QueryBaseComponent } from '../../../../../react-commons/query/QueryBaseComponent';
import { Form_DisplayComponentBaseView } from '../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { useMyForm } from '../../../../../react-commons/hooks/useMyForm';
import { DialogSize } from '../../../../../react-commons/components/data-display/dialog/ResizableDialog';
import { ContentSectionContentContent } from './ContentSectionContentContent';

export const ContentSectionContentEditDialog= ({ onClose, id, versionId }: {
    onClose: () => void;
    id: string;
    versionId: string;
}) => {
    const contentSectionContentActions = useContentSectionContentActions();

    const contentSectionContentQuery = contentSectionContentActions.useGetResource(id);

    const updateContentSectionContent = contentSectionContentActions.useUpdateResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: ContentSectionContentMutationResourceSchema,
        defaultValues: defaultContentSectionContentResource,
        submitHandler: async (data) => {
            await updateContentSectionContent.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: contentSectionContentQuery.data,
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Edit Content Section'}
            resourceType={[ResourceType.CONTENT_SECTION, ResourceType.CONTENT_SECTION_CONTENT]}
            metaDataInfo={contentSectionContentQuery.data}
            dialogSize={DialogSize.MEDIUM_LARGE}
        >
            <QueryBaseComponent name="ContentSectionContent" query={contentSectionContentQuery}>
                <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                    <ContentSectionContentContent
                        id={contentSectionContentQuery.data?.id}
                        versionId={versionId}
                        form={form}
                        formNames={formNames}
                        readOnly={false}
                    />
                </Form_DisplayComponentBaseView>
            </QueryBaseComponent>
        </EditChildBaseDialog>
    );
};
